import styled from 'styled-components'

export const Wrapper = styled.span`
  > button {
    background-color: #e7f3fe !important;
    border-radius: 8px;
    color: #0085ff !important;
    padding: 0 8px;
    border: none;
    font-weight: 700;
    margin-right: 8px;
    &:hover {
      opacity: 0.7;
    }
  }
`

export const OptionsWrapper = styled.span`
  button {
    background-color: #f0f0f0 !important;
    border-radius: 8px;
    width: 32px;
    padding-left: 13px;
    color: #4c4c4c !important;
    svg {
      transition: 200ms;
    }
    &:hover {
      svg {
        opacity: 0.7;
      }
    }
  }
`
